var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Extract Vote UNIT",
        visible: _vm.isOpen,
        width: "7.2rem",
        "append-to-body": "",
        "close-on-click-modal": false,
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isOpen = $event
        },
      },
    },
    [
      _c("div", [
        _c(
          "div",
          {
            staticClass: "spaceLeft",
            staticStyle: { "margin-bottom": "0.42rem" },
          },
          [
            _c("div", { staticClass: "detail-title-2" }, [
              _vm._v(
                "Proposal No. " +
                  _vm._s(_vm.pageData.proposal && _vm.pageData.proposal.id)
              ),
            ]),
            _vm._v(" "),
            _vm.pageData.proposal && _vm.pageData.proposal.status
              ? _c("voteStatusComp", {
                  attrs: {
                    status: _vm.pageData.proposal.status,
                    over: _vm.pageData.over,
                    cumulative: _vm.pageData.vote,
                    threshold: _vm.threshold,
                  },
                  on: {
                    "update:status": function ($event) {
                      return _vm.$set(_vm.pageData.proposal, "status", $event)
                    },
                    "update:over": function ($event) {
                      return _vm.$set(_vm.pageData, "over", $event)
                    },
                    "update:cumulative": function ($event) {
                      return _vm.$set(_vm.pageData, "vote", $event)
                    },
                    "update:threshold": function ($event) {
                      _vm.threshold = $event
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "detail-item spaceLeft" }, [
            _c("span", { staticClass: "detail-item-label" }, [
              _vm._v("Total votes:"),
            ]),
            _vm._v(" "),
            _vm.pageData.proposal && _vm.pageData.proposal.totalWeight
              ? _c(
                  "span",
                  [
                    _c("big-number", {
                      attrs: { number: _vm.pageData.proposal.totalWeight },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("span", { staticClass: "unit" }, [_vm._v("UNIT")]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "detail-item spaceLeft" },
            [
              _c("span", { staticClass: "detail-item-label" }, [
                _vm._v("My vote :"),
              ]),
              _vm._v(" "),
              _c("big-number", { attrs: { number: _vm.pageData.weight } }),
              _vm._v(" "),
              _c("span", { staticClass: "unit" }, [_vm._v("UNIT")]),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.close } }, [_vm._v("Cancel")]),
          _vm._v(" "),
          _c("loading-btn", {
            staticClass: "common-btn-blue-sm",
            attrs: { label: "Extract" },
            on: { clickHandle: _vm.save },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }